import {
	musicRoomsCollection,
	usersCollection,
	firebase,
} from '../../config/firebase';

let state = {
	musicRoom: {},
	musicRooms: [],
	featuredMusicRooms: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	musicRoom: state => state.musicRoom,
	musicRooms: state => state.musicRooms,
	featuredMusicRooms: state => state.featuredMusicRooms,
	musicRoomLoading: state => state.loading,
	musicRoomNotification: state => state.notification,
};
let actions = {
	async getMusicRoom({ commit }, payload) {
		commit('setMusicRoomLoading', true);
		let musicRoomSnap = await musicRoomsCollection.doc(payload).get();
		let musicRoomData = musicRoomSnap.data();
		commit('setMusicRoomData', musicRoomData);
		commit('setMusicRoomLoading', false);
	},
	async getMusicRooms({ commit }) {
		commit('setMusicRoomLoading', true);
		musicRoomsCollection.onSnapshot(async snapshot => {
			let musicRooms = [];
			for (let doc of snapshot.docs) {
				let data = doc.data();
				let { added_by } = data;
				let userSnaps = await usersCollection.doc(added_by).get();
				let userData = userSnaps.data();
				data['profile_image'] = userData.profile_image;
				musicRooms.push({ id: doc.id, ...data });
			}
			commit('setMusicRoomsData', musicRooms);
			commit('setMusicRoomLoading', false);
		});
	},
	async getFeaturedMusicRooms({ commit }, payload) {
		commit('setMusicRoomLoading', true);
		musicRoomsCollection
			.where('added_by', '==', payload)
			.onSnapshot(async snapshot => {
				let musicRooms = [];
				for (let doc of snapshot.docs) {
					let data = doc.data();
					let { added_by } = data;
					let userSnaps = await usersCollection.doc(added_by).get();
					let userData = userSnaps.data();
					data['profile_image'] = userData.profile_image;
					musicRooms.push({ id: doc.id, ...data });
				}
				commit('setFeaturedMusicRoomsData', musicRooms);
				commit('setMusicRoomLoading', false);
			});
	},
	async addMusicRoom({ commit }, payload) {
		commit('setMusicRoomLoading', true);
		try {
			await musicRoomsCollection.add({
				...payload,
				added_at: firebase.firestore.Timestamp.now(),
			});
			commit('setMusicRoomsNotification', {
				message: 'Job Added',
				type: 'success',
			});
		} catch (err) {
			commit('setMusicRoomsNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicRoomLoading', false);
		}
	},
	async editMusicRoom({ commit }, payload) {
		let { id } = payload;
		delete payload.id;
		commit('setMusicRoomLoading', true);
		try {
			await musicRoomsCollection.doc(id).update({ ...payload });
			commit('setMusicRoomsNotification', {
				message: 'Job Updated',
				type: 'success',
			});
		} catch (err) {
			commit('setMusicRoomsNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicRoomLoading', false);
		}
	},
	async deleteMusicRoom({ commit }, payload) {
		commit('setMusicRoomLoading', true);
		try {
			await musicRoomsCollection.doc(payload).delete();
			commit('setMusicRoomsNotification', {
				message: 'Job Deleted',
				type: 'success',
			});
		} catch (err) {
			commit('setMusicRoomsNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setMusicRoomLoading', false);
		}
	},
};
let mutations = {
	setMusicRoomData(state, payload) {
		state.musicRoom = payload;
	},
	setMusicRoomsData(state, payload) {
		state.musicRooms = payload;
	},
	setFeaturedMusicRoomsData(state, payload) {
		state.featuredMusicRooms = payload;
	},
	setMusicRoomLoading(state, payload) {
		state.loading = payload;
	},
	setMusicRoomsNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
